<template>
  <div class="page-container">
    <Filter :params="params.filter(item=> item.internalUser !== false)" :add="authList.includes('robot:add')" @search="searchData" @add="addNewRobot">
      <template #handle>
        <el-form-item>
          <el-button  v-show="authList.includes('robot:show')" v-if="userInfo.internalUser && !standard" type="primary" plain @click="setOtaIsShow">{{$t('equipment.robot.showOTA')}}</el-button>
        </el-form-item>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage" select :selectable="selectable" @select="handleSelect">
      <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" width="130"/>
      <el-table-column v-if="userInfo.internalUser" prop="robotIdOutStock" :label="$t('equipment.robot.robotCodeOutbound')" />
      <!-- <el-table-column prop="cabinet" :label="$t('collect.healthscorelist.ctrlCabCode')" width="130">
        <template #default="{ row }">
          <span>{{ row.cabNo }}</span>
          <el-button type="text" size="small" @click="bindCabinet" >关联控制柜</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="cabinet" :label="$t('equipment.cabinet.ctrlCode')" width="130">
        <template #default="scope">
          <span v-if="scope.row.cabNo?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabNo)">{{scope.row.cabNo}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabNo}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="servoVersion" :label="$t('equipment.cabinet.servoProgram')" />
      <el-table-column prop="productName" :label="$t('equipment.robot.productName')" />
      <el-table-column prop="modelName" :label="$t('equipment.cabinet.specModel')" />
      <!-- <el-table-column prop="companyName" label="公司名称" /> -->
      <!-- <el-table-column prop="industry" label="公司行业" /> -->
      <!-- <el-table-column prop="robotName" label="机器人名称" width="130" /> -->
      <!-- <el-table-column label="机器人位置">
          <template #default="scope">
            {{ scope.row.cityName + scope.row.areaName + scope.row.location }}
          </template>
        </el-table-column> -->
      <!-- <el-table-column prop="province" label="省"/>
        <el-table-column prop="city" label="市"/>
        <el-table-column prop="area" label="区"/> -->
      <el-table-column v-if="userInfo.internalUser" :label="$t('equipment.cabinet.otaConnected')">
        <template #default="scope">
          {{ scope.row.ota ? $t("activity.detail.yes") : $t("activity.detail.no") }}
        </template>
      </el-table-column>
      <el-table-column v-if="userInfo.internalUser && !standard" :label="$t('equipment.robot.displayFrontend')">
        <template #default="scope">
          {{ scope.row.isShow == 1 ? $t("activity.detail.yes") : $t("activity.detail.no") }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="produceTime" label="生产时间" width="160" /> -->
      <el-table-column prop="ledgerBatch" :label="$t('equipment.cabinet.outboundTime')" />
      <el-table-column v-if="userInfo.internalUser" prop="customer" :label="$t('activity.detail.customer')" />
      <el-table-column v-if="userInfo.internalUser" prop="remark" :label="$t('equipment.cabinet.remarks')" />
      <el-table-column prop="createBy" :label="$t('activity.list.creator')"/>
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" />
      <el-table-column prop="updateBy" :label="$t('status.largescreenm.updater')"/>
      <el-table-column prop="updateTime" :label="$t('collect.healthscorelist.updateTime')"/>
      <el-table-column :label="$t('activity.list.operation')" width="100" fixed="right">
        <template #default="{ row }">
          <el-button v-show="authList.includes('robot:edit')" type="text" size="mini" @click="editRobot(row)">{{$t('activity.list.edit')}}</el-button>
          <el-button v-if="row.isShow == 1 && !standard" type="text" size="mini" @click="cancelOtaIsShow(row)">{{$t('equipment.robot.hideOTA')}}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog v-model="dialogFormVisible" top="5vh" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="formRef" class="dialog-form" :model="form" :rules="formRules" :label-width="curLang == 'zh-CN' ? '120px' : curLang == 'en-US' ? '165px' : '180px'">
        <el-form-item :label="$t('activity.packetjoin.robotCode')" prop="robotId">
          <el-input v-model="form.robotId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('collect.healthscorelist.ctrlCabCode')" prop="cabNo">
          <el-select v-model="form.cabNo" :disabled="!!form.ota" :placeholder="$t('collect.healthscorelist.ctrlCabCode')" :remote-method="cabinetQuery" filterable remote clearable>
            <el-option
              v-for="(item) in cabinetList"
              :key="item.cabinetId"
              :label="item.cabinetId"
              :value="item.cabinetId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('status.largescreenm.robotName')">
          <el-input v-model="form.robotName" :placeholder="$t('status.largescreenm.enterRobotName')" />
        </el-form-item>
        <!-- <el-form-item label="规格型号" prop="modelName">
          <el-input v-model="form.modelName" placeholder="规格型号" />
        </el-form-item> -->
        <!-- <el-form-item label="公司名称">
          <el-input v-model="form.companyName" placeholder="公司名称" />
        </el-form-item> -->
        <!-- <el-form-item label="机器人名称">
          <el-input v-model="form.robotName" placeholder="机器人名称" />
        </el-form-item> -->
        <el-form-item :label="$t('equipment.cabinet.robotLocation')">
          <el-row>
            <el-col :span="6">
              <el-select v-model="form.country" :placeholder="$t('equipment.cabinet.country')">
                <el-option
                  v-for="item in countryList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.province" :placeholder="$t('equipment.cabinet.province')">
                <el-option
                  v-for="item in provinceList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.city" :placeholder="$t('equipment.cabinet.city')">
                <el-option
                  v-for="item in formCityList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.area" :placeholder="$t('equipment.cabinet.district')">
                <el-option
                  v-for="item in formAreaList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-input v-model="form.location" :placeholder="$t('equipment.cabinet.robotAddress')" />
        </el-form-item>
        <!-- <el-form-item label="是否接入OTA" prop="ota">
          <el-select v-model="form.ota" placeholder="是否接入OTA">
            <el-option
              v-for="item in options"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('equipment.cabinet.robotProdTime')">
          <el-date-picker
            v-model="form.produceTime"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('equipment.cabinet.robotProdTime')"
          />
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.robotOutboundTime')">
          <el-date-picker
            v-model="form.ledgerBatch"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('equipment.cabinet.robotOutboundTime')"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
import { formatTime } from "../../common/utils";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessage } from "element-plus";
import { standard } from '@/common/constant';
import { computed } from "vue";
import { useStore } from "vuex"
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  data() {
    const store = useStore()
    return {
      dialogFormVisible: false,
      formRef: null,
      form: {
        id: '',
        robotId: '',
        cabNo: '',
        robotName: '',
        // productName: '',
        // modelName: '',
        country: 80,
        province: '',
        city: '',
        area: '',
        location: '',
        ota: 0,
        produceTime: '',
        ledgerBatch: '',
      },
      formRules: {
        robotId: {
          required: true,
          message: this.$t('equipment.robot.enterRobotCode'),
          trigger: 'blur',
        },
        // modelName: {
        //   required: true,
        //   message: '请输入规格型号',
        //   trigger: 'blur',
        // },
        // ota: {
        //   required: true,
        //   message: '请选择是否接入OTA',
        //   trigger: 'change'
        // }
      },
      cabinetList: [],
      params: [
        {
          key: "robotId",
          value: '',
          label: this.$t('activity.packetjoin.robotCode'),
        },
        {
          key: "cabNo",
          value: '',
          label: this.$t('collect.healthscorelist.ctrlCabCode'),
        },
        {
          type: "Select",
          key: "ota",
          value: '',
          label: this.$t('equipment.cabinet.otaConnected'),
          options: {
            data: [{ name: this.$t('activity.detail.yes'), value: 1 }, { name: this.$t('activity.detail.no'), value: 0 }],
            label: "name",
            value: "value"
          },
          internalUser: JSON.parse(window.localStorage.getItem('userInfo')).internalUser
        },
        {
          type: "Select",
          key: "isShow",
          value: '',
          label: this.$t('equipment.robot.displayFrontend'),
          options: {
            data: [{ name: this.$t('activity.detail.yes'), value: 1 }, { name: this.$t('activity.detail.no'), value: 2 }],
            label: "name",
            value: "value"
          },
          internalUser: JSON.parse(window.localStorage.getItem('userInfo')).internalUser && !standard
        },
        {
          key: "customer",
          value: '',
          label: this.$t('activity.signin.customerName'),
          internalUser: JSON.parse(window.localStorage.getItem('userInfo')).internalUser
        },
        {
          type: "Date",
          key: "dateRange",
          value: [],
          label: this.$t('equipment.cabinet.outboundTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "range-separator": this.$t('activity.detail.to'),
            "start-placeholder": this.$t('activity.list.startDate'),
            "end-placeholder": this.$t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      countryList: [
        {
          nameCn: this.$t('equipment.cabinet.china'),
          nameEn: "China",
          regionId: '80',
        },
      ],
      provinceList: [],
      cityList: [],
      areaList: [],
      formCityList: [],
      formAreaList: [],
      robotStatusList: [], // 机器人状态下拉列表
      industryList: [], // 行业下拉列表
      options: [
        {
          id: true,
          name: this.$t('activity.detail.yes'),
        },
        {
          id: false,
          name: this.$t('activity.detail.no'),
        },
      ],
      batchDataList: [], // 表格多选
      userInfo: {},
      standard: standard,
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList'))
    };
  },
  watch: {
    "query.province": function(value, old) {
      if (value && value !== old) {
        console.log("province", value);
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.cityList = data;
        });
      }
    },
    "query.city": function(value, old) {
      if (value && value !== old) {
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.areaList = data;
        });
      }
    },
    "form.province": function(value, old) {
      if (value && value !== old) {
        console.log("province", value);
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.formCityList = data;
        });
      }
    },
    "form.city": function(value, old) {
      if (value && value !== old) {
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.formAreaList = data;
        });
      }
    },
  },
  created() {
    this.getData();
    this.getDataMap();
    try {
      const userInfo = window.localStorage.getItem('userInfo')
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo) || {}
      }
    } catch (error) {
      console.error(error)
    }
  },
  mounted() {
    // this.tableDataList = robotList({}).then(data => {
    //   this.tableDataList = data
    // })
    // this.$store.dispatch('status/robot', {})
    // .then(data => {
    //   console.log(data)
    // })
    // robotList({}).then(data => {
    //   this.tableDataList = data
    // })
  },
  methods: {
    getData() {
      request("getRobotList", {
        ...this.query,
        page: this.page,
        size: this.size,
      })
        .then((data) => {
          // this.tableDataList = data || [];
          // this.total = data.length;
          this.tableDataList = data.records;
          this.total = data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDataMap() {
      try {
        request("getArea", {
          parentId: 1,
        }).then((data) => {
          this.provinceList = data;
        });
        request("getRobotStatusMap").then((data) => {
          this.robotStatusList = data;
        });
        request("getIndustryList").then((data) => {
          this.industryList = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    searchData(data) {
      this.query = data;
      this.getData();
    },
    updatePage(page, size) {
      this.page = page || 1;
      this.size = size || 10;
      this.getData();
    },
    selectable (row) {
      if (row.isShow == 1) {
        return false
      } else {
        return true
      }
    },
    handleSelect(data) {
      this.batchDataList = data.map((item)=>{
        return item.id
      })
    },
    addNewRobot() {
      for (let key of Object.keys(this.form)) {
        this.form[key] = '';
      }
      this.dialogFormVisible = true;
      console.log(this.form);
    },
    editRobot(data) {
      for (let key of Object.keys(this.form)) {
        if (typeof data[key] != 'undefined') {
          this.form[key] = data[key];
        } else {
          this.form[key] = '';
        }
      }
      this.form.id = data.id;
      this.dialogFormVisible = true;
      this.cabinetQuery()
      console.log(this.form);
      return;
    },
    async onSubmit() {
      try {
        this.$refs.formRef && await this.$refs.formRef.validate()
        const api =  this.form.id ? 'updateRobot' : 'addRobot'
        await request(api, this.form)
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.dialogFormVisible = false
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },

    onCancel() {
      this.dialogFormVisible = false;
    },
    async setOtaIsShow() {
      try {
        await request('setOtaIsShow', {
          ids: this.batchDataList
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    async cancelOtaIsShow(row) {
      try {
        await request('cancelOtaIsShow', {
          id: row.id
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    async cabinetQuery (name) {
      try {
        this.cabinetList = []
        const res = await request('getAssociationCabinet', {
          id: this.form.id,
          cabinetId: name
        })
        this.cabinetList = (res || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    },
    dateChange() {
      console.log("dateChange: ", this.dateRange);
    },
    formatproduceTime(date) {
      console.log(date);
      if (date) {
        this.form.produceTime = formatTime(date);
      }
    },
    formatledgerBatch(date) {
      console.log(date);
      if (date) {
        this.form.ledgerBatch = formatTime(date);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
